// Valid login credentials for ChalkWalk representatives
const VALID_USERS = {
  "sumit@chalkwalkconsulting.com": "ChalkWalk@123",
  "sanket@chalkwalkconsulting.com": "ChalkWalk@123",
  "rupali@chalkwalkconsulting.com": "ChalkWalk@123",
  "anshika@chalkalkconsulting.com": "ChalkWalk@123",
  "fiza@chalkwalkconsulting.com": "ChalkWalk@123",
  "nishant@chalkwalkconsulting.com": "ChalkWalk@123",
  "navmika@chalkwalkconsulting.com": "ChalkWalk@123",
  "rubina@chalkwalkconsulting.com": "Rubina@2026",
};

export default VALID_USERS;
